import {Navigate, useParams} from 'react-router-dom';
import {PathUtility} from 'src/shared/constants/PathBuilder';

/** Legacy `/edit/{id}` URL — course editing is now in place on the workspace. */
export const CreateCourseEditRedirect = () => {
  const {definitionId} = useParams();
  return (
    <Navigate
      to={PathUtility.TrainingCourseView(String(definitionId), 'build')}
      replace
    />
  );
};
